import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Heading } from '../heading';
import { Slot, Slottable } from '../slot';
import { cardHeaderRecipe } from './styles/card-header.styles';
import type { CardHeaderPropsInterface } from './types/card-header.types';

/**
 * @since 10.0.0
 */
export const CardHeader = forwardRef<HTMLDivElement, CardHeaderPropsInterface>(
  (props: CardHeaderPropsInterface, forwardedRef) => {
    const { asChild = false, className, children, css: cssProp, divider = true, ...rest } = props;
    const styles = css(cardHeaderRecipe.raw({ divider }), cssProp);
    const Component = asChild ? Slot : 'div';
    return (
      <Component
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Card.Header"
        className={cx('c11n', 'c11n_card__header', styles, className)}
        {...rest}
      >
        {typeof children === 'string' ? (
          <Heading level={5}>{children}</Heading>
        ) : (
          <Slottable>{children}</Slottable>
        )}
      </Component>
    );
  },
);

CardHeader.displayName = 'Card.Header';
